export const countries = [
  {
    name: "Afghanistan",
    dial_code: "+93",
    code: "AF",
    flag: "🇦🇫",
  },
  {
    name: "Albania",
    dial_code: "+355",
    code: "AL",
    flag: "🇦🇱",
  },
  {
    name: "Algeria",
    dial_code: "+213",
    code: "DZ",
    flag: "🇩🇿",
  },
  {
    name: "Andorra",
    dial_code: "+376",
    code: "AD",
    flag: "🇦🇩",
  },
  {
    name: "Angola",
    dial_code: "+244",
    code: "AO",
    flag: "🇦🇴",
  },
  {
    name: "Argentina",
    dial_code: "+54",
    code: "AR",
    flag: "🇦🇷",
  },
  {
    name: "Armenia",
    dial_code: "+374",
    code: "AM",
    flag: "🇦🇲",
  },
  {
    name: "Australia",
    dial_code: "+61",
    code: "AU",
    flag: "🇦🇺",
  },
  {
    name: "Austria",
    dial_code: "+43",
    code: "AT",
    flag: "🇦🇹",
  },
  {
    name: "Azerbaijan",
    dial_code: "+994",
    code: "AZ",
    flag: "🇦🇿",
  },
  {
    name: "Bahrain",
    dial_code: "+973",
    code: "BH",
    flag: "🇧🇭",
  },
  {
    name: "Bangladesh",
    dial_code: "+880",
    code: "BD",
    flag: "🇧🇩",
  },
  {
    name: "Belarus",
    dial_code: "+375",
    code: "BY",
    flag: "🇧🇾",
  },
  {
    name: "Belgium",
    dial_code: "+32",
    code: "BE",
    flag: "🇧🇪",
  },
  {
    name: "Bhutan",
    dial_code: "+975",
    code: "BT",
    flag: "🇧🇹",
  },
  {
    name: "Bolivia",
    dial_code: "+591",
    code: "BO",
    flag: "🇧🇴",
  },
  {
    name: "Bosnia and Herzegovina",
    dial_code: "+387",
    code: "BA",
    flag: "🇧🇦",
  },
  {
    name: "Brazil",
    dial_code: "+55",
    code: "BR",
    flag: "🇧🇷",
  },
  {
    name: "Bulgaria",
    dial_code: "+359",
    code: "BG",
    flag: "🇧🇬",
  },
  {
    name: "Cambodia",
    dial_code: "+855",
    code: "KH",
    flag: "🇰🇭",
  },
  {
    name: "Cameroon",
    dial_code: "+237",
    code: "CM",
    flag: "🇨🇲",
  },
  {
    name: "Canada",
    dial_code: "+1",
    code: "CA",
    flag: "🇨🇦",
  },
  {
    name: "Chile",
    dial_code: "+56",
    code: "CL",
    flag: "🇨🇱",
  },
  {
    name: "China",
    dial_code: "+86",
    code: "CN",
    flag: "🇨🇳",
  },
  {
    name: "Colombia",
    dial_code: "+57",
    code: "CO",
    flag: "🇨🇴",
  },
  {
    name: "Costa Rica",
    dial_code: "+506",
    code: "CR",
    flag: "🇨🇷",
  },
  {
    name: "Croatia",
    dial_code: "+385",
    code: "HR",
    flag: "🇭🇷",
  },
  {
    name: "Cuba",
    dial_code: "+53",
    code: "CU",
    flag: "🇨🇺",
  },
  {
    name: "Cyprus",
    dial_code: "+357",
    code: "CY",
    flag: "🇨🇾",
  },
  {
    name: "Czech Republic",
    dial_code: "+420",
    code: "CZ",
    flag: "🇨🇿",
  },
  {
    name: "Denmark",
    dial_code: "+45",
    code: "DK",
    flag: "🇩🇰",
  },
  {
    name: "Dominican Republic",
    dial_code: "+1",
    code: "DO",
    flag: "🇩🇴",
  },
  {
    name: "Ecuador",
    dial_code: "+593",
    code: "EC",
    flag: "🇪🇨",
  },
  {
    name: "Egypt",
    dial_code: "+20",
    code: "EG",
    flag: "🇪🇬",
  },
  {
    name: "El Salvador",
    dial_code: "+503",
    code: "SV",
    flag: "🇸🇻",
  },
  {
    name: "Estonia",
    dial_code: "+372",
    code: "EE",
    flag: "🇪🇪",
  },
  {
    name: "Ethiopia",
    dial_code: "+251",
    code: "ET",
    flag: "🇪🇹",
  },
  {
    name: "Fiji",
    dial_code: "+679",
    code: "FJ",
    flag: "🇫🇯",
  },
  {
    name: "Finland",
    dial_code: "+358",
    code: "FI",
    flag: "🇫🇮",
  },
  {
    name: "France",
    dial_code: "+33",
    code: "FR",
    flag: "🇫🇷",
  },
  {
    name: "Georgia",
    dial_code: "+995",
    code: "GE",
    flag: "🇬🇪",
  },
  {
    name: "Germany",
    dial_code: "+49",
    code: "DE",
    flag: "🇩🇪",
  },
  {
    name: "Ghana",
    dial_code: "+233",
    code: "GH",
    flag: "🇬🇭",
  },
  {
    name: "Greece",
    dial_code: "+30",
    code: "GR",
    flag: "🇬🇷",
  },
  {
    name: "Guatemala",
    dial_code: "+502",
    code: "GT",
    flag: "🇬🇹",
  },
  {
    name: "Haiti",
    dial_code: "+509",
    code: "HT",
    flag: "🇭🇹",
  },
  {
    name: "Honduras",
    dial_code: "+504",
    code: "HN",
    flag: "🇭🇳",
  },
  {
    name: "Hong Kong",
    dial_code: "+852",
    code: "HK",
    flag: "🇭🇰",
  },
  {
    name: "Hungary",
    dial_code: "+36",
    code: "HU",
    flag: "🇭🇺",
  },
  {
    name: "Iceland",
    dial_code: "+354",
    code: "IS",
    flag: "🇮🇸",
  },
  {
    name: "India",
    dial_code: "+91",
    code: "IN",
    flag: "🇮🇳",
  },
  {
    name: "Indonesia",
    dial_code: "+62",
    code: "ID",
    flag: "🇮🇩",
  },
  {
    name: "Iran",
    dial_code: "+98",
    code: "IR",
    flag: "🇮🇷",
  },
  {
    name: "Iraq",
    dial_code: "+964",
    code: "IQ",
    flag: "🇮🇶",
  },
  {
    name: "Ireland",
    dial_code: "+353",
    code: "IE",
    flag: "🇮🇪",
  },
  {
    name: "Israel",
    dial_code: "+972",
    code: "IL",
    flag: "🇮🇱",
  },
  {
    name: "Italy",
    dial_code: "+39",
    code: "IT",
    flag: "🇮🇹",
  },
  {
    name: "Jamaica",
    dial_code: "+1",
    code: "JM",
    flag: "🇯🇲",
  },
  {
    name: "Japan",
    dial_code: "+81",
    code: "JP",
    flag: "🇯🇵",
  },
  {
    name: "Jordan",
    dial_code: "+962",
    code: "JO",
    flag: "🇯🇴",
  },
  {
    name: "Kazakhstan",
    dial_code: "+7",
    code: "KZ",
    flag: "🇰🇿",
  },
  {
    name: "Kenya",
    dial_code: "+254",
    code: "KE",
    flag: "🇰🇪",
  },
  {
    name: "Korea, South",
    dial_code: "+82",
    code: "KR",
    flag: "🇰🇷",
  },
  {
    name: "Kuwait",
    dial_code: "+965",
    code: "KW",
    flag: "🇰🇼",
  },
  {
    name: "Kyrgyzstan",
    dial_code: "+996",
    code: "KG",
    flag: "🇰🇬",
  },
  {
    name: "Latvia",
    dial_code: "+371",
    code: "LV",
    flag: "🇱🇻",
  },
  {
    name: "Lebanon",
    dial_code: "+961",
    code: "LB",
    flag: "🇱🇧",
  },
  {
    name: "Libya",
    dial_code: "+218",
    code: "LY",
    flag: "🇱🇾",
  },
  {
    name: "Liechtenstein",
    dial_code: "+423",
    code: "LI",
    flag: "🇱🇮",
  },
  {
    name: "Lithuania",
    dial_code: "+370",
    code: "LT",
    flag: "🇱🇹",
  },
  {
    name: "Luxembourg",
    dial_code: "+352",
    code: "LU",
    flag: "🇱🇺",
  },
  {
    name: "Macedonia",
    dial_code: "+389",
    code: "MK",
    flag: "🇲🇰",
  },
  {
    name: "Malaysia",
    dial_code: "+60",
    code: "MY",
    flag: "🇲🇾",
  },
  {
    name: "Maldives",
    dial_code: "+960",
    code: "MV",
    flag: "🇲🇻",
  },
  {
    name: "Malta",
    dial_code: "+356",
    code: "MT",
    flag: "🇲🇹",
  },
  {
    name: "Mexico",
    dial_code: "+52",
    code: "MX",
    flag: "🇲🇽",
  },
  {
    name: "Moldova",
    dial_code: "+373",
    code: "MD",
    flag: "🇲🇩",
  },
  {
    name: "Monaco",
    dial_code: "+377",
    code: "MC",
    flag: "🇲🇨",
  },
  {
    name: "Mongolia",
    dial_code: "+976",
    code: "MN",
    flag: "🇲🇳",
  },
  {
    name: "Montenegro",
    dial_code: "+382",
    code: "ME",
    flag: "🇲🇪",
  },
  {
    name: "Morocco",
    dial_code: "+212",
    code: "MA",
    flag: "🇲🇦",
  },
  {
    name: "Myanmar",
    dial_code: "+95",
    code: "MM",
    flag: "🇲🇲",
  },
  {
    name: "Nepal",
    dial_code: "+977",
    code: "NP",
    flag: "🇳🇵",
  },
  {
    name: "Netherlands",
    dial_code: "+31",
    code: "NL",
    flag: "🇳🇱",
  },
  {
    name: "New Zealand",
    dial_code: "+64",
    code: "NZ",
    flag: "🇳🇿",
  },
  {
    name: "Nicaragua",
    dial_code: "+505",
    code: "NI",
    flag: "🇳🇮",
  },
  {
    name: "Nigeria",
    dial_code: "+234",
    code: "NG",
    flag: "🇳🇬",
  },
  {
    name: "Norway",
    dial_code: "+47",
    code: "NO",
    flag: "🇳🇴",
  },
  {
    name: "Oman",
    dial_code: "+968",
    code: "OM",
    flag: "🇴🇲",
  },
  {
    name: "Pakistan",
    dial_code: "+92",
    code: "PK",
    flag: "🇵🇰",
  },
  {
    name: "Panama",
    dial_code: "+507",
    code: "PA",
    flag: "🇵🇦",
  },
  {
    name: "Paraguay",
    dial_code: "+595",
    code: "PY",
    flag: "🇵🇾",
  },
  {
    name: "Peru",
    dial_code: "+51",
    code: "PE",
    flag: "🇵🇪",
  },
  {
    name: "Philippines",
    dial_code: "+63",
    code: "PH",
    flag: "🇵🇭",
  },
  {
    name: "Poland",
    dial_code: "+48",
    code: "PL",
    flag: "🇵🇱",
  },
  {
    name: "Portugal",
    dial_code: "+351",
    code: "PT",
    flag: "🇵🇹",
  },
  {
    name: "Puerto Rico",
    dial_code: "+1",
    code: "PR",
    flag: "🇵🇷",
  },
  {
    name: "Qatar",
    dial_code: "+974",
    code: "QA",
    flag: "🇶🇦",
  },
  {
    name: "Romania",
    dial_code: "+40",
    code: "RO",
    flag: "🇷🇴",
  },
  {
    name: "Russia",
    dial_code: "+7",
    code: "RU",
    flag: "🇷🇺",
  },
  {
    name: "Rwanda",
    dial_code: "+250",
    code: "RW",
    flag: "🇷🇼",
  },
  {
    name: "Saudi Arabia",
    dial_code: "+966",
    code: "SA",
    flag: "🇸🇦",
  },
  {
    name: "Senegal",
    dial_code: "+221",
    code: "SN",
    flag: "🇸🇳",
  },
  {
    name: "Serbia",
    dial_code: "+381",
    code: "RS",
    flag: "🇷🇸",
  },
  {
    name: "Singapore",
    dial_code: "+65",
    code: "SG",
    flag: "🇸🇬",
  },
  {
    name: "Slovakia",
    dial_code: "+421",
    code: "SK",
    flag: "🇸🇰",
  },
  {
    name: "Slovenia",
    dial_code: "+386",
    code: "SI",
    flag: "🇸🇮",
  },
  {
    name: "South Africa",
    dial_code: "+27",
    code: "ZA",
    flag: "🇿🇦",
  },
  {
    name: "Spain",
    dial_code: "+34",
    code: "ES",
    flag: "🇪🇸",
  },
  {
    name: "Sri Lanka",
    dial_code: "+94",
    code: "LK",
    flag: "🇱🇰",
  },
  {
    name: "Sweden",
    dial_code: "+46",
    code: "SE",
    flag: "🇸🇪",
  },
  {
    name: "Switzerland",
    dial_code: "+41",
    code: "CH",
    flag: "🇨🇭",
  },
  {
    name: "Syria",
    dial_code: "+963",
    code: "SY",
    flag: "🇸🇾",
  },
  {
    name: "Taiwan",
    dial_code: "+886",
    code: "TW",
    flag: "🇹🇼",
  },
  {
    name: "Tajikistan",
    dial_code: "+992",
    code: "TJ",
    flag: "🇹🇯",
  },
  {
    name: "Tanzania",
    dial_code: "+255",
    code: "TZ",
    flag: "🇹🇿",
  },
  {
    name: "Thailand",
    dial_code: "+66",
    code: "TH",
    flag: "🇹🇭",
  },
  {
    name: "Tunisia",
    dial_code: "+216",
    code: "TN",
    flag: "🇹🇳",
  },
  {
    name: "Turkey",
    dial_code: "+90",
    code: "TR",
    flag: "🇹🇷",
  },
  {
    name: "Turkmenistan",
    dial_code: "+993",
    code: "TM",
    flag: "🇹🇲",
  },
  {
    name: "Uganda",
    dial_code: "+256",
    code: "UG",
    flag: "🇺🇬",
  },
  {
    name: "Ukraine",
    dial_code: "+380",
    code: "UA",
    flag: "🇺🇦",
  },
  {
    name: "United Arab Emirates",
    dial_code: "+971",
    code: "AE",
    flag: "🇦🇪",
  },
  {
    name: "United Kingdom",
    dial_code: "+44",
    code: "GB",
    flag: "🇬🇧",
  },
  {
    name: "United States",
    dial_code: "+1",
    code: "US",
    flag: "🇺🇸",
  },
  {
    name: "Uruguay",
    dial_code: "+598",
    code: "UY",
    flag: "🇺🇾",
  },
  {
    name: "Uzbekistan",
    dial_code: "+998",
    code: "UZ",
    flag: "🇺🇿",
  },
  {
    name: "Venezuela",
    dial_code: "+58",
    code: "VE",
    flag: "🇻🇪",
  },
  {
    name: "Vietnam",
    dial_code: "+84",
    code: "VN",
    flag: "🇻🇳",
  },
  {
    name: "Yemen",
    dial_code: "+967",
    code: "YE",
    flag: "🇾🇪",
  },
  {
    name: "Zambia",
    dial_code: "+260",
    code: "ZM",
    flag: "🇿🇲",
  },
  {
    name: "Zimbabwe",
    dial_code: "+263",
    code: "ZW",
    flag: "🇿🇼",
  },
]; 